export default __webpack_public_path__ + "static/zq-lee-VbDjv8-8ibc-unsplash-a1d19fd7b528c4a3b129e65e64bbf048.jpg";